import { URLS } from './Urls';
import { Strings } from './Strings';
import { OperationSection } from '@cobu/types';

const strings = Strings.get();

// Default operations data
export const DEFAULT_OPERATIONS: OperationSection[] = [
  {
    title: (strings.common.connect || '').toUpperCase(),
    data: [
      {
        title: (strings.common.chat || '').toUpperCase(),
        image: URLS.CHAT,
        linkType: strings.common.chat,
      },
      {
        title: (strings.common.events || '').toUpperCase(),
        image: URLS.EVENTS,
        linkType: strings.common.events,
      },
      {
        title: (strings.common.marketplace || '').toUpperCase(),
        image: URLS.MARKETPLACE,
        linkType: strings.common.marketplace,
      },
    ],
  },
];
